<template>
  <div class="dash container" v-if="questionsLoaded">
    <div class="title">
      <h1>{{translations[`${questionnaire.name}-title`]}}</h1>
    </div>
    <div class="questionnaire">
      <div class="col question">
        <wizard
          :questions="questions"
          :details="questionnaire.questions"
          :currentQuestionIndex="currentQuestionIndex"
          :questionnaireId="questionnaireId"
          :translations="translations"
          :key="update"
          @updateStepNumber="updateStepNumber"
          @onQuestionnaireCompleted="onQuestionnaireCompleted" />
      </div>
      <div class="col operation-details">
        <h2>{{translations['operation-details']}}</h2>
        <p class="eye" v-if="hasEye"><strong>{{translations['eye']}}:</strong> <span>{{eye}}</span></p>
        <p>{{translations[`${questionnaire.name}-explanation`]}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  import Wizard from '@/components/pages/Questionnaire/QuestionsWizard'
  import store from '@/store/'
  import {mapGetters, mapMutations} from 'vuex'
  import * as authTypes from 'raypro_ui/src/store/modules/auth/types'
  import * as websiteTypes from 'raypro_ui/src/store/modules/website/types'

  import page from '@/mixins/page'

  import {getPatientQuestionnaire, getPatientTranslations} from '@/api/questionnaire'

  export default {
    mixins: [page],
    components: {
      Breadcrumbs,
      Wizard
    },

    props: {
      questionnaireId: String,
      id: String
    },

    data() {
      return {
        questionnaire: [],
        questions: [],
        questionsLoaded: false,
        currentQuestionIndex: 1,
        title: 'Questionnaire',
        translations: [],
        update: 1,
        isSulcoflex: false
      }
    },

    mounted() {
      if(this.authUser) {
        this.getPatientQuestions()
      } else {
        store.commit(authTypes.TOKEN, this.$route.query.jwt)
        this.getPatientQuestions(this.params.id, this.params.questionnaireId)
      }

      this.setQuestion()
    },

    computed: {
      ...mapGetters(['authUser']),
      hasEye() {
        return !!this.$route.query.eye
      },
      params() {
        return this.$route.params
      },
      eye() {
        if(this.hasEye) {
          return this.$route.query.eye
        }
      }
    },

    methods: {
      ...mapMutations([websiteTypes.PATIENT_PRIVACY_URL, websiteTypes.PATIENT_PRIVACY_URL_LABEL]),

      getPatientQuestions() {
        getPatientQuestionnaire(this.id, this.questionnaireId)
          .then((questionnaire) => {
            const data = questionnaire.data.questionnaire

            this.isSulcoflex = questionnaire.data.sulcoflex
            this.questionnaire = data
            this.questions = this.setQuestions(data.questions)
            this.questionsLoaded = true
          })
          .catch(() => {
          })

        getPatientTranslations(this.id, 'question_label-')
          .then((response) => {
            for(const translation of response.data) {
              this.translations[translation.title.replace('question_label-', '')] = translation.body
            }
            this.$forceUpdate()
            this.update++
          })

        getPatientTranslations(this.id, 'privacy')
          .then((response) => {
            Object.values(response.data).forEach((item) => {
              if(item.title === 'privacy-label') {
                this[websiteTypes.PATIENT_PRIVACY_URL_LABEL](item.body)
              } else if(item.title === 'privacy-url') {
                this[websiteTypes.PATIENT_PRIVACY_URL](item.body)
              }
            })
          })
      },

      setQuestions(allQuestions) {
        const excludeTopic = this.isSulcoflex ?
          'Additional procedures question supplementary intraocular lens' : 'Additional procedures question sulcoflex explantation'

        allQuestions.forEach((question) => {
          if(this.isExcludedTopic(excludeTopic, question.topic)) {
            const excludeIndex = allQuestions.indexOf(question)

            allQuestions.splice(excludeIndex, 1)
          }
        })

        return allQuestions
      },

      isExcludedTopic(excludeTopic, questionTopic) {
        return excludeTopic.toLowerCase() === questionTopic.toLowerCase()
      },

      setQuestion() {
        const param = this.$route.query.question

        if(param) {
          this.currentQuestionIndex = parseInt(param)
        }
      },

      updateStepNumber(step) {
        this.currentQuestionIndex = step
      },

      onQuestionnaireCompleted() {
        this.$emit('onQuestionnaireCompleted')
      }
    }
  }
</script>

<style lang="sass" scoped>
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'

.dash
  &.container
    max-width: $max-width
    margin: auto

  .title
    color: $color-text
    margin-bottom: 30px
    padding-bottom: 15px
    border-bottom: 1px solid $color-grey-dark
    display: flex
    align-items: center
    width: 100%

    h1
      font-size: 18px
      color: $color-text-invert
      font-weight: bold

  .questionnaire
    color: $color-text
    @include media($media-medium)
      display: flex

      .col
        flex-basis: 35%
        padding: 0 20px

      .question
        flex-basis: 65%
        padding: 0 20px

  .operation-details
    color: $color-text-invert
    h2
      font-size: 12px
      text-transform: uppercase
      padding-bottom: 20px
      border-bottom: 1px solid $color-border

    .eye
      strong
        text-transform: uppercase

      span
        text-transform: capitalize
</style>



// WEBPACK FOOTER //
// src/components/pages/Questionnaire/Questionnaire.vue